import { GetLoyaltyCollectionsResponseDto } from '@src/api';
import { ChangeDetectionStrategy, Component, EventEmitter, inject, Output } from '@angular/core';
import { takeUntil } from 'rxjs';
import { BaseResizableComponent } from '@src/app/modules/base';

import { LoyaltyProgramPermService } from '../../services';
import { LoyaltyProgramCollectionsService, CollectionsStoreKeys, LpAllCollectionsStoreService } from '../services';

@Component({
  selector: 'lp-collection-list',
  templateUrl: './lp-collection-list.component.html',
  styleUrls: ['./lp-collection-list.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LpCollectionListComponent extends BaseResizableComponent {
  public readonly permService = inject(LoyaltyProgramPermService);
  private readonly loyaltyProgramCollectionsService = inject(LoyaltyProgramCollectionsService);
  private readonly lpAllCollectionsStore = inject(LpAllCollectionsStoreService);

  @Output() startCreate = new EventEmitter<void>();
  @Output() onSelectCollection = new EventEmitter<string>();

  loading = true;

  collections?: GetLoyaltyCollectionsResponseDto[];

  override ngOnInit(): void {
    super.ngOnInit();

    this.refresh();

    this.lpAllCollectionsStore
      .getDataObservable(CollectionsStoreKeys.All)
      .pipe(takeUntil(this.destroyed$$))
      .subscribe(allCollections => {
        this.collections = allCollections;
        this.loading = !allCollections;

        this.cdr.markForCheck();
      });
  }

  refresh() {
    this.loading = true;
    this.cdr.markForCheck();

    this.loyaltyProgramCollectionsService.loadAllCollections();
  }
}
